module.exports = __webpack_public_path__ + "static/media/ic-cityseek.5039568b.svg";